import React from 'react'
import { useTranslation } from 'react-i18next'

const ErrorPage = () => {
  const { t } = useTranslation(['portal'])
  return (
    <div className="error-container">
      <img
        alt="logo"
        className="logo-customizable"
        src="https://d2uqej7bo24sqa.cloudfront.net/eu-west-1_M0TknaCEM/ALL/20210803141040/assets/images/image.jpg"
      />
      <p className="error--desc">{t('noProfileMessage')}</p>
    </div>
  )
}

export default ErrorPage
